import { combineReducers } from '@reduxjs/toolkit'

import admin from '../components/admin/reducer'
import alerts from '../components/alerts/reducer'
import encountersHistory from '../components/Encounter/EncountersHistory/reducer'
import encounterSummaryForm from '../components/Encounter/EncounterSummary/reducer'
import encounter from '../components/Encounter/reducer'
import users from '../components/Header/User/reducer'
import auth from '../components/auth/auth-reducer'
import notificationsHistory from '../components/NotificationsHistory/reducer'
import encounterNavBar from '../components/PatientFolder/Assessment/reducer'
import caseClosure from '../components/PatientFolder/CaseManagement/reducer'
import narratives from '../components/PatientFolder/ClinicalImpressions/reducer'
import igao from '../components/PatientFolder/IGAO/reducer'
import patient from '../components/PatientFolder/reducer'
import reports from '../components/PatientFolder/Reports/reducer'
import insurance from '../components/PatientFolder/Standard/Demographics/Insurance/reducer'
import supportingDocs from '../components/PatientFolder/Standard/Goals/Choices/reducer'
import goals from '../components/PatientFolder/Standard/Goals/Goals/reducer'
import questionnaire from '../components/PatientFolder/Standard/lib/new-reducer'
import assessment from '../components/PatientFolder/Standard/lib/reducer'
import diagnosis from '../components/PatientFolder/Standard/MedicalHistory/Diagnosis/reducer'
import drugDrugInteractions from '../components/PatientFolder/Standard/Medications/reducer'
import esas from '../components/PatientFolder/Standard/Symptoms/ESAS/reducer'
import vitals from '../components/PatientFolder/Standard/Vitals/reducer'
import profile from '../components/profile/reducer'
import crudTable from '../components/shared/CrudTable/reducer'
import documents from '../components/shared/DocumentViewer/reducer'
import enrollments2 from '../components/shared/Enrollment/enrollmentReducer2'
import patientForm from '../components/shared/PatientForm/reducer'
import toast from '../components/shared/toast-stack/reducer'
import globalVars from '../lib/GlobalVars/reducer'
import { setupConstants } from '../lib/setup'

import app from './modules/app'
import previewer from './modules/previewer'
import sidebar from './modules/sidebar'

export let combinedReducer = combineReducers({
  app,
  sidebar,
  previewer,

  admin,
  alerts,
  assessment,
  auth,
  caseClosure,
  crudTable,
  diagnosis,
  documents,
  drugDrugInteractions,
  encounter,
  encounterNavBar,
  encountersHistory,
  encounterSummaryForm,
  enrollments2,
  esas,
  globalVars,
  goals,
  igao,
  insurance,
  narratives,
  notificationsHistory,
  patient,
  patientForm,
  profile,
  questionnaire,
  reports,
  supportingDocs,
  toast,
  users,
  vitals
})

export let reducer: typeof combinedReducer = (state, action) => {
  if (action.type === 'auth/USER_SIGNED_OUT') {
    // TODO: a little dirty way to solve CM-9547: App version is not shown on
    // page after logout (https://narushealth.atlassian.net/browse/CM-9547).
    // We need to preserve the app version in the state after logout, but I
    // didn't find a better way to do it other than to re-run initial constants
    // setup.

    // Since full state reset relies on passing an undefined state to the
    // reducer, we cannot use a partially preserved state: everything breaks.
    // Therefore, we sort of launch this setup in parallel.
    void setupConstants()

    return combinedReducer(undefined, action)
  }

  return combinedReducer(state, action)
}
